import { getSelectedWelcomeMessageId } from 'reduxes/slices/selected/selectors'
import { createSelector } from 'reselect'

import {
  getApiAnswers,
  getApiQuestions,
  getApiWelcomeMessages,
} from '../api/selectors'

export const getSelectedWelcomeMessage = createSelector(
  [getApiWelcomeMessages, getSelectedWelcomeMessageId],
  (welcomeMessages, welcomeMessageId) => {
    return welcomeMessages[welcomeMessageId]
  },
)

export const makeGetWelcomeMessageById = () =>
  createSelector(
    [getApiWelcomeMessages, (_, id) => id],
    (welcomeMessages, id) => {
      return welcomeMessages[id]
    },
  )

export const getPrevWelcomeMessageId = createSelector(
  [getApiQuestions, getApiAnswers, getSelectedWelcomeMessageId],
  (questions, answers, currentWelcomeMessageId) => {
    const answer = Object.values(answers).find(
      (a) => a.action === `welcome_message:${currentWelcomeMessageId}`,
    )
    return questions[answer?.question_id]?.welcome_message_id
  },
)

export const getWelcomeMessageLookup = createSelector(
  [getApiWelcomeMessages],
  (welcomeMessages) => {
    return Object.values(welcomeMessages).reduce((acc, welcomeMessage) => {
      acc[welcomeMessage.sgid] = welcomeMessage.id
      return acc
    }, {})
  },
)
